import React from 'react';

interface EventPosterProps {
  name: string;
  className?: string;
  date?: string;
}

/** Small event poster thumbnail used in list rows. Shared across mail components. */
export const EventPoster: React.FC<EventPosterProps> = ({ name, className = '', date }) => {
  const cleanName = name.replace(/\s+(list|attendees|contacts)$/i, '').trim() || name;
  const words = cleanName.split(/\s+/).filter(Boolean);
  const word1 = words[0]?.toUpperCase() || 'EVENT';
  const word2 = words.length > 1 ? words[1].toUpperCase() : '';

  return (
    <div
      className={`w-12 h-12 rounded-lg bg-gradient-to-br from-[#1b4332] to-[#081c15] border border-[#2d6a4f] flex flex-col items-center justify-center p-1 text-center select-none flex-shrink-0 ${className}`}
    >
      <span className="text-[8px] font-black text-emerald-400 tracking-wider uppercase truncate max-w-full leading-tight">
        {word1}
      </span>
      {word2 && (
        <span className="text-[7px] font-bold text-white uppercase truncate max-w-full leading-tight mt-0.5">
          {word2}
        </span>
      )}
      {date && (
        <span className="text-[5px] text-emerald-300 font-semibold mt-1 bg-emerald-500/10 px-1 py-0.5 rounded leading-none">
          {date}
        </span>
      )}
    </div>
  );
};
